import { render, staticRenderFns } from "./merchantBalance.vue?vue&type=template&id=d3457118&scoped=true"
import script from "./merchantBalance.vue?vue&type=script&lang=ts"
export * from "./merchantBalance.vue?vue&type=script&lang=ts"
import style0 from "./merchantBalance.vue?vue&type=style&index=0&id=d3457118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3457118",
  null
  
)

export default component.exports